import { Fragment, useEffect, useState } from "react";
import Input from "../../../form/Input";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
// import { bannerAddEdit } from "../../../../services/bannersService";
import FileUploadSingle from "../../../form/FileUploadSingle";
import Textarea from "../../../form/Textarea";
import { toast } from "react-toastify";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import AvatarUpload from "../../../common/AvatarUpload";
import { initialsValue, removeDuplicateFromArray } from "../../../../helpers";
import Tabs from "../../../elements/Tabs";
import {
  categoryAddEdit,
  categoryDetails,
  categoryList,
} from "../../../../services/categoryService";
import { useDebounce } from "../../../../hooks/useDebounce";
import Select from "../../../form/select/Select";

const validation = {
  name: { required: true, message: "Title is required" },
};

function FormComponent({
  getResponse = () => {},
  close = () => {},
  data,
  lang,
}) {
  const queryClient = useQueryClient();
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    formValidate,
  } = useForm({
    validationRules: validation,
  });

  const { data: details } = useQuery({
    queryKey: ["categoryDetails", data?._id],
    queryFn: async () => {
      const res = await categoryDetails({ id: data?._id });
      return res;
    },
    enabled: !!data?._id,
  });

  useEffect(() => {
    return () => {
      queryClient.removeQueries({ queryKey: ["categoryDetails", data?._id] });
    };
  }, []);

  useEffect(() => {
    if (details?.data?._id) {
      if (details?.status === 200) {
        const value = {
          ...details?.data,
          name: details?.data?.name?.[lang] || "",
          description: details?.data?.description?.[lang] || "",
          image: details?.data?.media?.image?.url,
          parent: details?.data?.parent,
        };
        delete value?._id;
        delete value?.media;
        if (
          value &&
          typeof value === "object" &&
          Object.keys(value)?.length > 0
        ) {
          setFieldsValue(value);
        }
      }
    }
  }, [details?.data?._id, lang]);

  console.log({ values });

  const { mutate, isPending: isLoading } = useMutation({
    mutationFn: async (val) => {
      const payload = {
        ...val,
        name: { ...details?.data?.name, [lang]: val?.name },
        description: {
          ...details?.data?.description,
          [lang]: val?.description,
        },
        image: val?.image,
        type: "event-category",
        ...(data?._id && { id: data?._id }),
      };
      return await categoryAddEdit(payload);
    },
    onSuccess: (res) => {
      if (res?.status === 200 || res?.status === 201) {
        toast.success(res?.message);
        getResponse(res);
        return res;
      } else {
        toast.warning(res?.message || res?.error);
      }
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const [categoryFilters, setCategoryilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "-createdAt",
  });
  const [categoryKeyword, setCategorykeyword] = useState("");
  const categorySearch = useDebounce(categoryKeyword, 300);

  const { data: categories } = useQuery({
    queryKey: ["category", categoryFilters, categorySearch],
    queryFn: async () => {
      const res = await categoryList({
        ...categoryFilters,
        type: "event-category",
        ...(categorySearch && { keyword: categorySearch }),
      });
      if (res?.docs?.status === 200) {
        return {
          ...res?.docs,
          data: removeDuplicateFromArray([
            ...(categories?.data || []),
            ...res?.docs?.data,
          ]),
        };
      } else {
        if (categories?.data?.length > 0) {
          return categories;
        } else {
          return res;
        }
      }
    },
  });

  function loadData(e, obj, setData = () => {}) {
    if (
      Math.ceil(e.target.scrollTop) + 20 >=
        e.target.scrollHeight - e.target.clientHeight &&
      obj?.metadata?.hasNextPage
    ) {
      setData((pre) => ({
        ...pre,
        page: obj?.metadata?.nextPage,
      }));
    }
  }

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-12 gap-x-4 gap-y-4">
        <div className="col-span-12 px-6 flex items-center justify-center relative">
          <AvatarUpload
            src={
              values?.image instanceof File
                ? URL.createObjectURL(values?.image)
                : values?.image
            }
            onChange={(file) => {
              handleChange({ target: { name: "image", value: file } });
            }}
            alt="profile"
            initial={initialsValue(details?.name)}
          />
        </div>
        <div className="relative col-span-6">
          <Input
            label="Category Name"
            inputPlaceholder={"Enter Category Name"}
            inputName="name"
            value={values?.name || ""}
            onChange={handleChange}
            {...formValidate(errors, "name")}
          />
        </div>

        {/* {Boolean(
          !data?._id || data?.ancestors?.length === 0 || !data?.ancestors
        ) && ( */}
        <Fragment>
          <div className="relative col-span-6">
            <Select
              label={"Sub Category"}
              placeholder="Select Sub Category"
              selectedValue={values?.parent || ""}
              dropdownData={removeDuplicateFromArray(
                (categories?.data || [])
                  ?.filter((item) => {
                    if (item._id === data?._id) return false;
                    const isDescendant = data?.ancestors?.some(
                      (ancestor) => ancestor._id === item._id
                    );
                    return !isDescendant;
                  })
                  ?.map((item) => ({
                    name: item?.name?.[lang],
                    value: item?._id,
                  })),
                "value"
              )}
              // isDisabled={values?.ancestors?.length > 0}
              onChange={(val) => {
                console.log({ val });
                handleChange({ target: { name: "parent", value: val } });
              }}
              onScroll={(e) => {
                loadData(e, categories, setCategoryilters);
              }}
            />
          </div>
          {/* <div className="relative col-span-6">
              <Select
                label={"Category Type"}
                placeholder="Select Parent Category"
                selectedValue={values?.types || ""}
                dropdownData={[
                  {
                    name: "Category",
                    value: "category",
                  },
                  {
                    name: "Sub Category",
                    value: "subcategory",
                  },
                ]}
                isDisabled
                onChange={(val) => {
                  handleChange({ target: { name: "types", value: val } });
                }}
                onScroll={(e) => {
                  loadData(e, categories, setCategoryilters);
                }}
                {...formValidate(errors, "types")}
              />
            </div> */}
        </Fragment>
        {/* )} */}

        <div className="col-span-12">
          <Textarea
            label="Description"
            inputValue={values?.description || ""}
            inputName={"description"}
            onChange={handleChange}
          />
        </div>
        {/* <div className="relative col-span-12">
          <FileUploadSingle
            label={"Upload Image"}
            labelClasses={"!mb-2"}
            value={values?.image || ""}
            onChange={(file) => {
              handleChange({ target: { name: "image", value: file } });
            }}
            {...formValidate(errors, "image")}
          />
        </div> */}
      </div>
      <div className="relative col-span-4 mt-5">
        <div className="flex items-center justify-center gap-4">
          <Button
            buttonType="submit"
            buttonLabel={"Save Category"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-primary !bg-transparent !text-primary hover:!bg-primary hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            {...(isLoading && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel={"Cancel"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-primary !bg-transparent !text-primary hover:!bg-primary hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            buttonFunction={close}
          />
        </div>
      </div>
    </form>
  );
}

const ManageCategory = ({ getResponse = () => {}, close = () => {}, data }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const tabs = [
    {
      label: "English",
      content: (
        <FormComponent
          getResponse={getResponse}
          close={close}
          data={data}
          lang={"en"}
        />
      ),
    },
    {
      label: "Spanish",
      content: (
        <FormComponent
          getResponse={getResponse}
          close={close}
          data={data}
          lang={"es"}
        />
      ),
    },
  ];

  return (
    <div className="h-full p-4">
      <Tabs
        items={tabs}
        setSelectedIndex={setSelectedIndex}
        selectedIndex={selectedIndex}
      />
    </div>
  );
};

export default ManageCategory;
